<div class="wrapper-tabs-items">
  <div class="header-tab-items">
    <div class="wrapper-custom-search">
      <img class="icon-search" src="../../../assets/icons/outline/icon-search.svg" alt="">
      <input type="text" [placeholder]="'SEARCH.search' | translate" [(ngModel)]="searchTerm" (input)="onSearchChange($event)" (focus)="onFocus()" (blur)="onBlur()" >
      <div (click)="resetSearch()" class="wrapper-delete-search">
        <img src="../../../assets/icons/outline/icon-close.svg" alt="">
      </div>
    </div>
    <button *ngIf="loggedUser && loggedUser.id === user_id" (click)="loggedUser ? openColumnIdeas.emit(true) : openPublicListModal.emit()" [ngClass]="{'no-text': isFocused}" class="custom-btn custom-btn--outline-gray">
      <img src="../../../../../../assets/icons/outline/icon-columns-ideas.svg" alt="">
      <span>{{'NEW_TEXT_TRANSLATE.suggest_columns' | translate}}</span>
    </button>
    <button *ngIf="loggedUser && loggedUser.id === user_id" (click)="loggedUser ? autoPopulate() : openPublicListModal.emit()" [ngClass]="{'no-text': isFocused}" class="custom-btn custom-btn--outline-gray">
      <img src="../../../../../../assets/icons/outline/icon-autopopulate.svg" alt="">
      <span>{{'NEW_TEXT_TRANSLATE.suggest_items' | translate}}</span>
    </button>
    <button *ngIf="loggedUser && loggedUser.id === user_id" (click)="loggedUser ? populateData() : openPublicListModal.emit()" [ngClass]="{'no-text': isFocused}" [disabled]="!items.length"  class="custom-btn custom-btn--outline-gray">
      <img src="../../../../../../assets/icons/outline/icon-autopopulate.svg" alt="">
      <span>{{ 'NEW_TEXT_TRANSLATE.populate_data' | translate }}</span>
    </button>
    <button (click)="loggedUser ? isFilterModalOpen = !isFilterModalOpen : openPublicListModal.emit()" class="custom-btn custom-btn--circle-outline">
      <img src="../../../../assets/icons/outline/icon-filter.svg" alt="">
    </button>
    <div *ngIf="loggedUser" class="switch-grid">
      <div class="btn-switch-grid" (click)="addNewRow = false" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, listId, 'cards']" [ngClass]="{'active': itemsView === 'cards'}">
        <img src="../../../../../assets/icons/outline/icon-menu.svg" alt="">
      </div>
      <div class="btn-switch-grid" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, listId, 'table']" [ngClass]="{'active': itemsView === 'table'}">
        <img src="../../../../../assets/icons/outline/icon-posts.svg" alt="">
      </div>
    </div>
    <button *ngIf="loggedUser?.id === user_id" (click)="addNewItem()" class="custom-btn custom-btn--outline">
      <span>{{'NEW_TEXT.new_item' | translate}}</span>
      <img src="../../../../../assets/icons/outline/icon-plus.svg" alt="">
    </button>
  </div>
  <div *ngIf="itemsView === 'cards'" (click)="loggedUser ? '' : openPublicListModal.emit()" class="wrapper-list-items">
    <div *ngFor="let item of items; index as i" [routerLink]="loggedUser && [PAGES_AND_PATHS.singleItem.pagePath, item.id]"
      class="wrapper-item-list-view">
      <div class="tl-d-flex tl-align-center between-full">
        <div class="tl-d-flex tl-align-center">
          <span class="number">{{i + 1}}</span>
          <div class="wrapper-list-item-image">
            <img [ngSrc]="item.lyst_item_image_url !== null ? item.lyst_item_image_url : 'assets/images/no-image.png'" alt="" width="44" height="44" loading=lazy>
          </div>
          <div class="wrapper-list-item-info" *ngIf="!(columns && columns[3])">
            <span class="info-item" *ngIf="!(columns && columns[3])">Name</span>
            <span class="name">{{item.name}}</span>
          </div>
          <div class="wrapper-list-item-info wrapper-multiple-list-item-info" *ngIf="columns && columns[3]">
            <div class="wrapper-multiple-item-info">
              <span class="info-item" *ngIf="columns && columns[3]">{{columns[2]?.name}}</span>
              <span class="name">{{item.name | trimToLength: 50}}</span>
            </div>
            <div class="wrapper-multiple-item-info" *ngIf="columns && columns[3]">
              <span class="info-item">{{columns[3]?.name}}</span>
              <span class="name" *ngIf="rows[i] && rows[i][0] && rows[i][0].value">{{rows[i][0].value | trimToLength: 50}}</span>
              <span class="name" *ngIf="!(rows[i] && rows[i][0] && rows[i][0].value)">/</span>
            </div>
            <div class="wrapper-multiple-item-info" *ngIf="columns && columns[4]">
              <span class="info-item">{{columns[4]?.name}}</span>
              <span class="name" *ngIf="rows[i] && rows[i][1] && rows[i][1].value">{{rows[i][1].value | trimToLength: 50}}</span>
              <span class="name" *ngIf="!(rows[i] && rows[i][1] && rows[i][1].value)">/</span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="loggedUser && loggedUser?.id !== user_id;" (click)="openCopyModal(item, $event)"  appClickedOutside (clickedOutside)="isCopyDropdownOpen = false;" class="wrapper-delete-item copy">
        <img src="./assets/icons/outline/icon-view-more.svg" alt="">
        <div  (click)="isCopyModalOpen = true" *ngIf="isCopyDropdownOpen  && selectedItem?.id === item.id" class="dropdown-delete-item">
          <img src="../../../../../../assets/icons/outline/icon-lists.svg" alt="">
          <span>{{'NEW_TEXT.copy_to_my_list' | translate}}</span>
        </div>
      </div>
    </div>
    <div *ngIf="!items.length" class="no-item-list">
      <img src="../../../../../../assets/icons/illustration/no-item-illustration.svg" alt="">
      <span>{{'LISTS.oops_there_are_no_list_items' | translate}}</span>
    </div>
  </div>
  <div *ngIf="itemsView === 'table'" class="wrapper-add-items">
    <div class="wrapper-table-items">
      <div class="wrapper-header-table-item">
        <div class="wrapper-header-table-row-item">
          <div class="column-table-row-item">
            <span></span>
          </div>
          <div class="column-table-row-item">
            <span>#</span>
          </div>
          <div class="column-table-row-item">
            <span *ngIf="columns && columns[1]" (click)="loggedUser ? openUpdateColumnModal(columns[1]) : openPublicListModal.emit()">{{columns[1]?.name}}</span>
          </div>
          <div class="column-table-row-item">
            <span *ngIf="columns && columns[2]" (click)="loggedUser ? openUpdateColumnModal(columns[2]) : openPublicListModal.emit()">{{columns[2]?.name}}</span>
          </div>
          <div *ngFor="let column of columns | slice:3" class="column-table-row-item">
            <span (click)="loggedUser ? openUpdateColumnModal(column) : openPublicListModal.emit()">{{column.name}}</span>
            <div *ngIf="loggedUser?.id === user_id;" class="delete-column" (click)="openDeleteColumnModal(column)">
              <img src="../../../../../../assets/icons/outline/icon-delete.svg" alt="">
            </div>
          </div>
          <div class="column-table-row-item">
            <div *ngIf="loggedUser?.id === user_id;" (click)="loggedUser ? isAddNewColumnOpen = true : openPublicListModal.emit()" class="wrapper-add-new-row-item">
              <div class="wrapper-plus">
                <img src="../../../../../assets/icons/outline/icon-plus.svg" alt="">
              </div>
              <span>
                {{'NOTIFICATION.new' | translate}}
              </span>
            </div>
          </div>
          <div class="column-table-row-item">
            <span></span>
          </div>
        </div>
      </div>
      <div class="wrapper-content-table-item" cdkDropList
      (cdkDropListDropped)="drop($event)">
        <app-item-row *ngFor="let item of items; index as i; let isLast = last"
                      [item]="item"
                      [index]="i"
                      [user_id]="user_id"
                      [addNewRow]="addNewRow"
                      [columns]="columns"
                      [isLast]="isLast"
        ></app-item-row>
        <div *ngIf="loggedUser?.id === user_id;" (click)="addNewItem()" class="wrapper-add-new-row-item">
          <div class="wrapper-plus">
            <img src="../../../../../assets/icons/outline/icon-plus.svg" alt="">
          </div>
          <span>{{'NOTIFICATION.new' | translate}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-filter-items *ngIf="isFilterModalOpen" (closeModal)="isFilterModalOpen = false;" [columns]="columns" [filters]="filters"></app-filter-items>
<app-add-new-column *ngIf="isAddNewColumnOpen"
(reqObj)="handleColumnName($event)"
(closeModal)="isAddNewColumnOpen = false; selectedColumn = null"
[selectedColumn]="selectedColumn"
></app-add-new-column>
<tl-confirm-modal *ngIf="isDeleteModalOpen" [modalIcon]="'../../../../../assets/icons/outline/icon-delete.svg'"
  [modalTitle]="deleteModalText.title" [confirmBtnText]="deleteModalText.button"
  [modalDescription]="deleteModalText.description" (cancelModal)="isDeleteModalOpen = false"
  (confirmModal)="takeAction()">
</tl-confirm-modal>
<app-copy-item-modal *ngIf="isCopyModalOpen" [url]="url" [selectedItem]="selectedItem" (closeModal)="isCopyModalOpen = false; selectedItem = null;" (isOpenToastOpen)="isOpenToastOpen = $event" (selectedListAndItem)="selectedListAndItem = $event"></app-copy-item-modal>
<app-copy-toast-notification *ngIf="isOpenToastOpen" [selectedListAndItem]="selectedListAndItem" (closeModal)="closeCopyModal()"></app-copy-toast-notification>
